import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';
import { d as defineCustomElement$5 } from './p-BLpMhFGJ.js';
import { d as defineCustomElement$4 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$3 } from './p-CtbK9Pbz.js';
import { d as defineCustomElement$2 } from './p-cR96ip-k.js';
import { d as defineCustomElement$1 } from './p-Bn01tsA6.js';
import { d as debounce } from './p-Dg7s1ivP.js';

const scrollIndicatorCss = ":host{--push-top:calc(var(--fade-size-top)/2);--push-bottom:calc(var(--fade-size-bottom)/2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:1;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-height:100%;position:relative;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{display:flex;flex:1;flex-direction:column;-webkit-mask-image:linear-gradient(to bottom,#0000 0,#0000 var(--push-top,0),#000 calc(var(--fade-size-top, 0) + var(--push-top, 0)),#000 calc(100% - var(--push-bottom, 0) - var(--fade-size-bottom, 0)),#0000 calc(100% - var(--push-bottom, 0)));mask-image:linear-gradient(to bottom,#0000 0,#0000 var(--push-top,0),#000 calc(var(--fade-size-top, 0) + var(--push-top, 0)),#000 calc(100% - var(--push-bottom, 0) - var(--fade-size-bottom, 0)),#0000 calc(100% - var(--push-bottom, 0)));overflow-x:hidden;overflow-y:auto;scrollbar-width:thin}.tag{left:.125rem;opacity:1;position:absolute;transition:opacity .2s linear,top .25s ease,bottom .25s ease;z-index:1}.tag-up{top:0}.tag-down{bottom:.125rem}:host([data-at-top]) .tag-up{display:none;opacity:0;top:0}:host([data-at-bottom]) .tag-down{bottom:0;display:none;opacity:0}";

const SCROLL_FADE_SIZE = 36;
const SCROLL_TAG_TOLERANCE = 20;
const WuiScrollIndicator = /*@__PURE__*/ proxyCustomElement(class WuiScrollIndicator extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleScroll = ({ currentTarget }) => {
            if (currentTarget !== this.scrollElm) {
                return;
            }
            this.updateElm();
        };
        this.setRef = (elm) => {
            this.scrollElm = elm;
            this.updateElm();
            this.scrollElm?.removeEventListener('scroll', this.handleScroll);
            this.scrollElm?.addEventListener('scroll', this.handleScroll);
        };
        this.isScrollable = false;
        this.showTagsLabel = true;
        this.handleWindowResize = debounce(() => {
            this.updateElm();
        }, 300);
    }
    updateElm() {
        requestAnimationFrame(() => {
            if (!this.scrollElm) {
                return;
            }
            const { scrollHeight, clientHeight, scrollTop } = this.scrollElm;
            this.isScrollable = scrollHeight > clientHeight;
            if (!this.isScrollable) {
                // Remove all classes
                this.elm.style.setProperty('--fade-size-top', '0');
                this.elm.style.setProperty('--fade-size-bottom', '0');
                return;
            }
            const scrollBottom = scrollHeight - clientHeight - scrollTop;
            this.atTop = scrollTop <= SCROLL_TAG_TOLERANCE;
            this.atBottom = scrollBottom <= SCROLL_TAG_TOLERANCE;
            this.elm.style.setProperty('--fade-size-top', `${Math.min(scrollTop, SCROLL_FADE_SIZE)}px`);
            this.elm.style.setProperty('--fade-size-bottom', `${Math.min(scrollBottom, SCROLL_FADE_SIZE)}px`);
        });
    }
    connectedCallback() {
        window.addEventListener('resize', this.handleWindowResize);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleWindowResize);
    }
    render() {
        const tagLabel = this.showTagsLabel ? 'Scroll for more' : undefined;
        return (h(Host, { key: '468b3677ab52f01a4f5dc27ec5bd9df06b89dafa', "data-at-top": this.atTop || undefined, "data-at-bottom": this.atBottom || undefined, "data-tag-centered": this.showTagsLabel ? undefined : true }, h("div", { key: 'cd2f3ff9fd8e883d38a7528c670797b520bfac73', part: "inner", class: "inner", ref: this.setRef }, h("slot", { key: 'c91f5647e805fcb2196d0b8ea3703fe48609dc89' })), this.isScrollable && (h(Fragment, { key: '3f7f1d3b8c6f9e6abd87051b4bbf22ddd78689c6' }, h("wui-tag", { key: 'e0ca99b12be23c55a05aab12758497837a537f73', class: "tag tag-up", label: tagLabel, icon: "arrow-up", action: true, onClick: ({ currentTarget }) => {
                this.scrollElm?.scrollTo({ top: 0, behavior: 'instant' });
                currentTarget?.blur();
            } }), h("wui-tag", { key: 'f1d15be512d450b24e8e60b6b6a7079766c2b672', class: "tag tag-down", label: tagLabel, icon: "arrow-down", action: true, onClick: ({ currentTarget }) => {
                this.scrollElm?.scrollTo({ top: 99999999, behavior: 'instant' });
                currentTarget?.blur();
            } })))));
    }
    get elm() { return this; }
    static get style() { return scrollIndicatorCss; }
}, [257, "wui-scroll-indicator", {
        "showTagsLabel": [4, "show-tags-label"],
        "isScrollable": [32],
        "atTop": [32],
        "atBottom": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-scroll-indicator", "wui-close-button", "wui-icon", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-scroll-indicator":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiScrollIndicator);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiScrollIndicator as W, defineCustomElement as d };
